import { NavLink, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Bike, ListChecks, History, Wallet, User, Bell } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { BrandLogo } from "@/components/BrandLogo";
import { useDeliveryStatus } from "./useDeliveryStatus";

const TABS = [
  { to: "/delivery", label: "Runs", icon: ListChecks, end: true },
  { to: "/delivery/history", label: "History", icon: History, end: false },
  { to: "/delivery/earnings", label: "Earn", icon: Wallet, end: false },
  { to: "/delivery/notifications", label: "Alerts", icon: Bell, end: false },
  { to: "/delivery/profile", label: "Profile", icon: User, end: false },
];

export default function DeliveryShell() {
  const { user } = useAuth();
  const loc = useLocation();
  const { online } = useDeliveryStatus();

  return (
    <div className="min-h-screen bg-background flex flex-col max-w-2xl mx-auto lg:border-x lg:shadow-sm" data-testid="delivery-shell">
      <header className="sticky top-0 z-30 bg-card/90 backdrop-blur border-b" data-testid="delivery-header">
        <div className="px-4 py-3 flex items-center gap-3">
          <BrandLogo mark size={40} className="shrink-0" />
          <div className="flex-1 min-w-0">
            <div className="font-display text-base leading-tight text-primary">Babu Delivery</div>
            <div className="text-[11px] text-muted-foreground flex items-center gap-1.5">
              <span className={`w-1.5 h-1.5 rounded-full ${online ? "bg-primary" : "bg-muted-foreground"}`} />
              {user?.name || "Partner"} · {online ? "Online" : "Offline"}
            </div>
          </div>
          {online ? (
            <Badge className="bg-primary hover:bg-primary" data-testid="header-online-badge">ONLINE</Badge>
          ) : (
            <Badge variant="secondary" data-testid="header-offline-badge">OFFLINE</Badge>
          )}
        </div>
      </header>

      <main className="flex-1 pb-24" key={loc.pathname}>
        <Outlet />
      </main>

      <nav className="fixed bottom-0 inset-x-0 lg:static lg:mt-auto bg-card/95 backdrop-blur border-t z-30" data-testid="delivery-tabbar">
        <div className="max-w-2xl mx-auto grid grid-cols-5">
          {TABS.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={`tab-${label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex flex-col items-center gap-1 py-2.5 text-[11px] transition-colors ${
                  isActive ? "text-primary font-semibold" : "text-muted-foreground hover:text-foreground"
                }`
              }
            >
              <Icon className="w-5 h-5" />
              <span>{label}</span>
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
